import { computed } from 'vue';
import { useBreakpoints } from '@vueuse/core';
import { screens } from '@pkg/config/tailwind/screens';

const useBreakpointsOnce = () => useBreakpoints(screens);

// Don't use this for styling or visibility of elements, as it will always be false until JS has loaded on the client.
export const useIsDesktop = () => {
  const breakpoints = useBreakpointsOnce();
  return breakpoints.greaterOrEqual('desk');
};

/** True when viewport is tablet-wide (768px) up to but not including desk (1200px). */
export const useIsTablet = () => {
  const breakpoints = useBreakpointsOnce();
  const gteTabletWide = breakpoints.greaterOrEqual('tablet-wide');
  const ltDesk = breakpoints.smaller('desk');
  return computed(() => gteTabletWide.value && ltDesk.value);
};

